import Iconfont from '@/components/iconfont/iconfont'
import { Column, Expaned, Row } from '@/components/layout/layout'
import useBemClass from '@/utils/hooks/useBEMClass'
import React, { useMemo, useRef, useState } from 'react'
import FilterContainer from '../../../goods-manage/components/filter-container/filter-container'
import './good-sale-filter.scss'
import classnames from 'classnames'
import useSelectList from '@/utils/hooks/useSelectList'
import { goodSaleFilterStore } from './store'
import Tip from '@/components/tip/tip'
import { Switch } from 'antd'
import { showLayer } from '@/utils/layer'
import { ChooseGoodsCategoryDialog } from '../../../goods-manage/goods-storage/goods-library/modules/edit-goods/modules/goods-category/goods-category'
import {
    goodsModel,
    IGoodsCategory,
} from '../../../goods-manage/goods-storage/goods-library/modules/edit-goods/modules/model'
import GroupPopoverMutiple from '../../../goods-manage/components/group-popover/group-popover-mutiple'
import { usePopoverVisible } from '@/components/popover-confirm/usePopoverVisible'
import useSetDataTogether from '@/utils/hooks/useSetDataTogether'
import $msg from '@/utils/message'
interface GoodSaleFilterProps {
    onClick: () => void
    type: number
}

const scene = [
    {
        id: 1,
        name: '收银台',
    },
    {
        id: 2,
        name: '微商城',
    },
]

const GoodSaleFilter: React.FC<GoodSaleFilterProps> = props => {
    const cls = useBemClass('good-sale-filter')

    const setAllData = useSetDataTogether()

    const senceSelectAction = useSelectList<{ id: number; name: string }>(goodSaleFilterStore.scene, 'id')
    const [merge_pricing_method, setMerge] = useState<boolean>(goodSaleFilterStore.mergePrice)
    const [category, setCategory] = useState<IGoodsCategory[]>(goodSaleFilterStore.category)
    const group = useRef<(string | number | undefined)[]>(goodSaleFilterStore.group)
    const secondGroup = useRef<(string | number)[]>(goodSaleFilterStore.secondGroup)
    const [groupName, setGroupName] = useState<string[]>(goodSaleFilterStore.groupName)

    const categroyName = useMemo(() => category.map(c => c.name).join('、'), [category])

    const popoverOptions = usePopoverVisible()

    return (
        <FilterContainer
            styles={{
                right: 0,
                top: '180px',
                paddingTop: '20px',
            }}
            onCancel={props.onClick}
            onConfirm={() => {
                if (!senceSelectAction.select.length) {
                    return $msg('warning', '至少选择一种数据场景')
                }
                goodSaleFilterStore.setCategory(category)
                goodSaleFilterStore.setGroup(group.current)
                goodSaleFilterStore.setSecondGroup(secondGroup.current)
                goodSaleFilterStore.setGroupName(groupName)
                goodSaleFilterStore.setScene(senceSelectAction.select)
                goodSaleFilterStore.setMergePrice(merge_pricing_method)
                props.onClick()
            }}
            onReset={() => {
                group.current = []
                secondGroup.current = []
                setAllData(() => {
                    setCategory([])
                    setMerge(false)
                    setGroupName([])
                    senceSelectAction.setSelect([])
                })
            }}
        >
            <Row>
                <Column>
                    <Row data-height-50 data-align-items-center>
                        <div
                            data-color-999
                            data-font-size-14
                            data-margin-right-25
                            style={{
                                flexShrink: 0,
                            }}
                        >
                            场景筛选
                        </div>
                        <Row
                            style={{
                                flexWrap: 'wrap',
                                alignItems: 'center',
                            }}
                        >
                            {scene.map(item => (
                                <div
                                    className={classnames(cls('tag'), {
                                        [cls('tag', 'active')]: senceSelectAction.has(item),
                                    })}
                                    key={item.id}
                                    onClick={() => {
                                        senceSelectAction.toggle(item)
                                    }}
                                >
                                    <div hidden={!senceSelectAction.has(item)} className={cls('tag', 'icon')}>
                                        <Iconfont name="iconyixuan" size={14} />
                                    </div>
                                    <span>{item.name}</span>
                                </div>
                            ))}
                        </Row>
                    </Row>
                    {props.type === 0 && (
                        <Row data-height-50 data-align-items-center data-margin-bottom-8>
                            <div
                                data-color-999
                                data-font-size-14
                                data-margin-right-25
                                style={{
                                    flexShrink: 0,
                                }}
                            >
                                查看设置
                            </div>
                            <div data-color-000 data-font-size-14 data-margin-right-4>
                                多售价商品合并
                            </div>
                            <Tip
                                size={14}
                                styles={{
                                    marginRight: '16px',
                                }}
                                text="开启后，原本分为几条的多售价商品数据会按照 商品信息被合并为一条。合并的商品单位默认为 库存单位，便于查看某种商品的总体销售情况。"
                            />
                            <Switch
                                checked={merge_pricing_method}
                                onChange={() => {
                                    setMerge(v => !v)
                                }}
                            />
                        </Row>
                    )}
                </Column>
                <Column data-expaned className={cls('right')}>
                    {[0, 1].includes(props.type) && (
                        <Row data-align-items-center data-width-100p data-height-50>
                            <div data-color-999 data-font-size-14 data-margin-right-40>
                                类目筛选
                            </div>
                            <div
                                className={cls('ipt')}
                                onClick={() => {
                                    showLayer(
                                        <ChooseGoodsCategoryDialog
                                            goodsModel={goodsModel}
                                            mutiple
                                            selectCategory={category}
                                            onSubmit={c => {
                                                setCategory(c)
                                            }}
                                        />,
                                    )
                                }}
                            >
                                {categroyName ? <div>{categroyName}</div> : <div data-color-999>请选择类目</div>}
                                <Iconfont name="icon6youjiantou-20" size={14} />
                            </div>
                        </Row>
                    )}
                    {[0, 2].includes(props.type) && (
                        <Row data-align-items-center data-width-100p data-height-50>
                            <div data-color-999 data-font-size-14 data-margin-right-40>
                                分组筛选
                            </div>
                            <Expaned>
                                <GroupPopoverMutiple
                                    {...popoverOptions.options}
                                    onSubmit={(g, second, name) => {
                                        setAllData(() => {
                                            group.current = g
                                            secondGroup.current = second
                                            setGroupName(name)
                                        })
                                        popoverOptions.hidden()
                                    }}
                                >
                                    <div className={cls('ipt')}>
                                        {groupName.length ? (
                                            <div>{groupName.join('、')}</div>
                                        ) : (
                                            <div data-color-999>请选择分组</div>
                                        )}
                                        <Iconfont name="icon6youjiantou-20" size={14} />
                                    </div>
                                </GroupPopoverMutiple>
                            </Expaned>
                        </Row>
                    )}
                </Column>
            </Row>
        </FilterContainer>
    )
}

export default GoodSaleFilter
